// extracted by mini-css-extract-plugin
export default {"InfoBubbleWrapper":"InfoBubble_InfoBubbleWrapper__DzRur","InfoBubble":"InfoBubble_InfoBubble__d9-ze","icon":"InfoBubble_icon__i61hR","directional":"InfoBubble_directional__kRP+J"};